import { gql } from "@apollo/client"

export const QUALITY_BASE_FRAG = gql`
  fragment QualityBaseFrag on QualitySampleType {
    id
    recordedOn
    qualityRejection
    reason
    status
  }
`
